import PropTypes from 'prop-types';
import React, { useState } from 'react';

import useMutate from '../../hooks/use_mutate';
import useTranslation from '../../hooks/use_translation';
import Form from '../form';
import Input from '../form/input';
import Submit from '../form/submit';
import SectionHeader from '../framework/sections/section-header';
import Trans from '../translation/trans';

const OfferNewCustomers = () => {
	const { trigger } = useMutate('subscription.add');
	const [information, setInformation] = useState();
	const { t } = useTranslation('component_offer_new_customers');

	const handleSubmit = async (values, { isSubmitting, setSubmitting }) => {
		if (isSubmitting) return;
		setInformation();

		if (values.email) {
			const result = await trigger({
				attributes: { email: values.email },
			});
			setInformation(result ? 'ok' : 'error');
		}

		setSubmitting(false);
	};

	return (
		<>
			<div className="container py-3">
				<div className="row align-items-start justify-content-between mt-3">
					<div className="col-lg-5 mb-2 ">
						<SectionHeader
							excerpt={t('t8')}
							headingType="h2"
							hideButton={true}
							resetSpacing
							title={t('t1')}
						/>
					</div>
					<div className="col-md-6 mb-2">
						{information == 'ok' && <p>{t('t6')}</p>}
						{(!information == 'ok' || information != 'ok') && (
							<Form
								initialValues={{
									email: '',
								}}
								onSubmit={handleSubmit}
							>
								<div className="row g-3">
									<div className="col">
										<label className="visually-hidden" htmlFor="input_email">
											{t('t2')}
										</label>
										<Input
											hideLabel
											name="email"
											placeholder={t('t2')}
											type="email"
										/>
										<div className="form-text" id="emailHelp">
											<Trans i18nKey="t3" t={t} />
										</div>

										{information == 'error' && (
											<div className="alert alert-danger p-2 mt-2">
												<p className="xs mb-0">{t('t7')}</p>
											</div>
										)}
									</div>
									<div className="col-auto">
										<Submit className="mb-3" name={t('t5')} size="sm" />
									</div>
								</div>
							</Form>
						)}
					</div>
				</div>
			</div>
		</>
	);
};

OfferNewCustomers.propTypes = {
	children: PropTypes.node,
};

export default OfferNewCustomers;
